import {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Link,
  Unlink,
  List,
  ListOrdered,
  TextQuote,
  Code,
  Undo,
  Redo,
  Image
} from "lucide-svelte"

export default {
  bold: {
    icon: Bold,
    title: "Bold",
    toggleName: "toggleBold"
  },
  italic: {
    icon: Italic,
    title: "Italic",
    toggleName: "toggleItalic"
  },
  underline: {
    icon: Underline,
    title: "Underline",
    toggleName: "toggleUnderline"
  },
  strike: {
    icon: Strikethrough,
    title: "Strikethrough",
    toggleName: "toggleStrike"
  },
  bulletList: {
    icon: List,
    title: "Bullet List",
    toggleName: "toggleBulletList"
  },
  orderedList: {
    icon: ListOrdered,
    title: "Ordered List",
    toggleName: "toggleOrderedList"
  },
  blockquote: {
    icon: TextQuote,
    title: "Blockquote",
    toggleName: "toggleBlockquote"
  },
  code: {
    icon: Code,
    title: "Code",
    toggleName: "toggleCode"
  },
  codeBlock: {
    icon: Code,
    title: "Codeblock",
    toggleName: "toggleCodeBlock"
  },
  undo: {
    icon: Undo,
    title: "Undo",
    toggleName: "toggleUndo"
  },
  redo: {
    icon: Redo,
    title: "Redo",
    toggleName: "toggleRedo"
  },
  link: {
    icon: Link,
    title: "Link",
    toggleName: "toggleLink"
  },
  image: {
    icon: Image,
    title: "Image",
    toggleName: ""
  }
}

export const onlyTextButtons: ButtonType[][] = [
  ["bold", "italic", "underline", "strike"],
  ["bulletList", "orderedList", "blockquote"]
]
